<template>
  <div class="content">
    <h2 class="m-n">だれでも掲示板</h2>

    <div class="row m-t-md">
      <a href="/request">一覧へ戻る</a>
    </div>

    <div class="row m-t-md">
      <div class="hpanel">
        <div class="panel-body p-xs">
          <div class="text-left text-title">
            <b>{{ commentOwner.title }}</b>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="hpanel">
        <div class="panel-body p-xs">
          <div class="text-left">
            <span class="seller_name">{{
              commentOwner.seller.seller_id
            }}</span>
          </div>
          <div class="text-left m-l-md m-t-sm content_comment">{{ commentOwner.content }}</div>
          <div class="text-left m-l-md m-t-sm created_date">{{ commentOwner.createdAt }}</div>
          <div class="text-left m-l-md m-t-sm flexbox">
            <img v-if="!isLiked" src="/static/dists/img/ic_unlike.png" width="30px" @click="likeRequest"/>
            <img v-else src="/static/dists/img/ic_liked.png" width="30px"/>
            <span class="like_count m-l-sm"><span class="like_number">{{ formatAmount(commentOwner.likesCount) }} </span>  いいね</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="hpanel">
        <div class="panel-body p-xs">
          <div class="text-left">
            <span class="seller_name">{{
              userInfo.sellerId
            }}</span>
          </div>
          <textarea type="text" class="form-control m-t-sm comment_box" v-model="commentContent" placeholder="ここにコメント..."/>
          <button
            type="button"
            class="btn btn-warning m-t-sm"
            @click="postComment"
            :disabled="!commentContent"
          >
            コメント
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="hpanel">
        <div class="panel-body p-xs">
          <div class="text-left flexbox">
            <span class="seller_name">アクティビティ</span>
            <div class="m-l-md sort_comment">
              <a @click="getCommentOwner(true)">新しい投稿順</a> ／ <a @click="getCommentOwner(false)">古い投稿順</a>
            </div>
          </div>
          <template  v-for="(cmt, index) in commentArr">
            <div
              :key="'cmt' + index"
              class="m-l-xl m-r-xl p-sm align_baseline"
              :class="{ 'border_comment': index != (commentArr.length - 1)}"
            >
              <div class="comment-index">
                <span v-if="isNewest">{{ commentArr.length - index}}.</span>
                <span v-else>{{ index + 1}}.</span>
              </div>
              <div class="comment-item">
                <div class="text-left">
                  <span class="seller_name">{{
                    cmt.seller.seller_id
                  }}</span>
                  <span class="text-left m-t-xs created_date">{{ cmt.createdAt }}</span>
                </div>
                <div class="text-left m-t-xs content_comment">{{ cmt.comment }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from '@/common/utility'
import { mapGetters } from 'vuex'
import RequestService from '@/services/requestservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      loader: null,
      isShowRequest: false,
      isLiked: false,
      commentContent: '',
      idRequest: 0,
      commentOwner: {
        title: '',
        content: '',
        createdAt: '',
        seller: {
          seller_name: '',
          seller_id: ''
        },
        likesCount: 0
      },
      commentArr: [],
      isNewest: true
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    })
  },
  mounted () {
    this.$events.listen('done', () => {
      this.loader && this.loader.hide()
    })
  },
  created () {
    this.idRequest = this.$route.params.id
    this.getCommentOwner(true)
  },
  methods: {
    formatAmount (value) {
      return value === null || typeof value === 'undefined' || value === 0
        ? ''
        : `${Util.formatMoney(value)}`
    },
    async likeRequest () {
      let logParams = {
        name: eventCode.requests.click_like_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.isLiked = true
      let self = this
      self.loader = self.$loading.show()
      const likeRequestBody = {
        data: {
          type: 'request_goods',
          attributes: {}
        }
      }

      await RequestService.likeRequest(likeRequestBody, this.idRequest)
        .then(response => {
          self.commentOwner.likesCount = response.recordList.data.likesCount
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
        .finally(() => {
          self.loader && self.loader.hide()
        })
    },
    async postComment () {
      let logParams = {
        name: eventCode.requests.click_comment_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let self = this
      self.loader = self.$loading.show()
      const commentRequestBody = {
        data: {
          type: 'request_comments',
          attributes: {
            comment: self.commentContent
          }
        }
      }

      await RequestService.commentRequest(commentRequestBody, this.idRequest)
        .then(response => {
          self.commentContent = ''
          self.commentArr = response.recordList.data.relatedComments
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
        .finally(() => {
          self.loader && self.loader.hide()
        })
    },
    async getCommentOwner (latest) {
      this.isNewest = latest
      let self = this
      self.loader = self.$loading.show()
      await RequestService.getRequestOwner(this.idRequest, latest)
        .then(response => {
          self.commentOwner = response.data
          self.isLiked = response.data.liked
          self.commentArr = response.included

          let logParams = {
            name: eventCode.requests.show_detail,
            properties: {
              selectedRequest: response.data
            }
          }
          EventService.postTrackLog(logParams)
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
        .finally(() => {
          self.loader && self.loader.hide()
        })
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.seller_name {
  font-size: 16px;
  font-weight: 600;
  color: #34495e;
}

.seller_id {
  font-size: 12px;
  color: #34495e;
}

.created_date {
  font-size: 12px;
  color: #BFBFBF;
}

.like_count {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  align-self: flex-end;
  color: #34495e;
}

.like_number {
  font-size: 25px;
  color: #008cc6;
  align-self: flex-end;
}

img:hover {
  cursor: pointer;
}

.sort_comment {
  font-size: 12px;
}

.border_comment {
  border-bottom: 1px solid #BFBFBF;
}

.content_comment {
  white-space: pre;
  color: #34495e;
}

.text-title {
  font-size: 25px;
  line-height: 16px;
  padding: 4px 0 1px 0px
}

.comment_box {
  line-height: 2;
  min-height: 100px;
}

.align_baseline {
  align-items: baseline;
}
.text-title, .content_comment {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.comment-item {
  width: calc(100% - 54px);
  display: inline-block;
  margin: 10px 0;
}

.comment-index {
  margin-top: 10px;
  width: 30px;
  display: inline-block;
  vertical-align: top;
}

@media (max-width: 768px) {
  .content {
    padding: 15px 10px !important;
  }
  .text-title {
    line-height: unset;
    font-size: 20px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .hpanel .panel-body {
    padding: 10px 5px !important;
  }
  .content_comment {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .align_baseline {
    margin: 5px 0px 5px 10px;
    display: block;
    padding-right: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/request/RequestComment.vue